export const XS_FONT_SIZE = "0.75rem";
export const SM_FONT_SIZE = "0.875rem";
export const DEFAULT_FONT_SIZE = "1rem";
export const MD_FONT_SIZE = "1.125rem";
export const LG_FONT_SIZE = "1.5rem";
export const XL_FONT_SIZE = "2rem";
export const XXL_FONT_SIZE = "3rem";

export const SM_PADDING = "0.5rem";
export const DEFAULT_PADDING = "1rem";
export const MD_PADDING = "1.5rem";
export const LG_PADDING = "2rem";
export const XL_PADDING = "3rem";
export const XXL_PADDING = "4rem";

export const LIGHT_FONT_WEIGHT = "300";
export const DEFAULT_FONT_WEIGHT = "400";
export const MEDIUM_FONT_WEIGHT = "500";
export const SEMI_FONT_WEIGHT = "600";
export const BOLD_FONT_WEIGHT = "700";

export const PRIMARY_COLOR = "#2f8ae1";
export const SECONDARY_COLOR = "#1861a6";
export const WHITE_COLOR = "#ffffff";
export const DISABLED_COLOR = "#EBEBE4";
